import { HTMLAttributes, forwardRef, useEffect, useImperativeHandle, useRef } from "react";
import './index.scss'

export interface ScrollViewRef {
    scrollTop: (value: number) => void
}

const ScrollView = forwardRef((prop: {
    scrollY?: boolean,
    scrollX?: boolean,
    enableBackToTop: boolean,
    scrollWithAnimation: boolean,
    useWindowScroll?: boolean,
    onReachBottom?: () => void
} & HTMLAttributes<HTMLDivElement>, ref) => {

    const scroller = useRef<HTMLDivElement>();

    useImperativeHandle(ref, () => ({
        scrollTop: (value: number) => {
            if (prop.useWindowScroll) {
                window.scrollTo({
                    top: 0,
                    behavior: prop.scrollWithAnimation ? "smooth" : "auto"
                })
                return;
            }
            const scrollInfo = {
                top: prop.scrollY ? (value || 0) : 0,
                left: prop.scrollX ? (value || 0) : 0,
                behavior: prop.scrollWithAnimation ? "smooth" : undefined
            };
            scroller.current?.scrollTo(scrollInfo as any)
            console.log("滚动", scroller.current, scrollInfo)
        }
    }))

    useEffect(() => {
        const scrollListener = function () {
            if (!prop.useWindowScroll) {
                return
            }
            var docElement = document.documentElement;
            var docBody = document.body;
            var scrollTop = docElement.scrollTop || docBody.scrollTop;
            var windowHeight = docElement.clientHeight || docBody.clientHeight;
            var scrollHeight = docElement.scrollHeight || docBody.scrollHeight;
            if (scrollHeight - scrollTop - windowHeight <= 50 && prop.onReachBottom) {
                prop.onReachBottom()
            }
        }
        window.addEventListener("scroll", scrollListener)
        return () => {
            window.removeEventListener("scroll", scrollListener)
        }
    }, [prop.useWindowScroll, prop.onReachBottom])

    return <div
        ref={(ref) => {
            scroller.current = ref as HTMLDivElement
        }}
        onScroll={(e) => {
            if (!prop.useWindowScroll) {
                const dom = scroller.current;
                if (prop.scrollY && prop.onReachBottom) {
                    const scrollHeight = dom?.scrollHeight || 0;
                    const clientHeight = dom?.clientHeight || 0;
                    const scrollTop = dom?.scrollTop || 0;
                    if (scrollHeight - scrollTop - clientHeight <= 1) {
                        prop.onReachBottom()
                    }
                } else if (prop.scrollX && prop.onReachBottom) {
                    const scrollWidth = dom?.scrollWidth || 0;
                    const clientWidth = dom?.clientWidth || 0;
                    const scrollLeft = dom?.scrollLeft || 0;
                    if (scrollWidth - scrollLeft - clientWidth <= 1) {
                        prop.onReachBottom()
                    }
                }
            }

        }}
        {...prop}
        className={`scroll-view ${prop.className || ''} ${prop.scrollY ? 'scroll-y' : ''} ${prop.scrollX ? 'scroll-x' : ''}`}
    >
        {prop.children}
    </div>
})

export default ScrollView;